/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as api from '../api';
import * as types from '../constants/actions';

export const fetchReservation = makeAsyncAction(
    types.FETCH_RESERVATION,
    (resId) => () => api.getReservation(resId),
    'reservation'
);

export const createReservation = makeAsyncAction(
    types.CREATE_RESERVATION,
    (reservation) => () => api.createReservation(reservation),
    'reservation'
);

export const createReservations = makeAsyncAction(
    types.CREATE_RESERVATIONS,
    (reservations) => () => api.createReservations(reservations),
    'reservations'
);

export const updateReservation = makeAsyncAction(
    types.UPDATE_RESERVATION,
    (reservation) => () => api.updateReservation(reservation),
    'reservation'
);

export function updateCurrentReservation(updates) {
    return (dispatch) =>
        dispatch({ type: types.UPDATE_CURRENT_RESERVATION, payload: updates });
}
